import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Card, Header } from '@driftt/dds'
import { access } from '@driftt/traffic-control'

import { TimelineEventsFeed } from 'components/AccountDrawer/ActivityFeed'
import ActivityTimeline from 'components/ActivityTimeline'
import { DateRange } from 'components/DateRangePicker'
import { CurrentUserContext } from 'context/currentUserContext'
import { formatRangeToFullDate } from 'utils/formatDates'
import { segmentTrack, TrackType } from 'utils/tracking'

import { AccountDetailsPageParams } from '..'
import AccountActivityStats from '../AccountActivityStats'
import AccountSiteVisitInfoTable from '../AccountSiteVisitInfo'
import AIEngagementSummary from '../AIEngagementSummary'
import EngagementScoreSection from '../EngagementScoreSection'
import TopVisitors from '../TopVisitors'

import styles from './styles.module.css'

interface FeedTabProps {
  companyData?: any
  explainData?: any
}

const FeedTab = ({ companyData, explainData }: FeedTabProps) => {
  const [dateRange, setDateRange] = useState<DateRange | undefined>(undefined)
  const { id: accountId } = useParams<AccountDetailsPageParams>()

  const hasAISummary = access.hasGates('prospector_ai_summary')

  const currentUser = useContext(CurrentUserContext)
  const trackAction = (action: string, additionalData?: any) => {
    segmentTrack(TrackType.ACTIVITY_TIMELINE_ACTION, {
      userId: currentUser?.id,
      orgId: currentUser?.orgId,
      action,
      page: 'AccountDetailsPage',
      ...additionalData
    })
  }

  return (
    <>
      <div className={styles.leftSide}>
        <div className={styles.feedContainer}>
          <div>
            {hasAISummary && <AIEngagementSummary accountId={accountId} />}
            <Card>
              <Header variant="h3">Activity timeline</Header>
              <ActivityTimeline
                dateRange={dateRange}
                setDateRange={setDateRange}
                accountId={accountId}
                accountName={companyData?.name}
                useExternalData={false}
              />
            </Card>
            {dateRange && (
              <div className={styles.timelineDateContainer}>
                <div className={styles.timelineDateBorder} />
                <div className={styles.timelineDate}>
                  {formatRangeToFullDate(dateRange)}
                  <span
                    className={styles.timelineDateClear}
                    onClick={() => setDateRange(undefined)}>
                    Jump to most recent
                  </span>
                </div>
              </div>
            )}
          </div>
          <TimelineEventsFeed
            accountId={accountId}
            trackAction={trackAction}
            inDrawer={false}
            scrollTargetId="accountDetailsPage"
            dateRange={dateRange}
            setDateRange={setDateRange}
          />
        </div>
      </div>
      <div className={styles.rightSide}>
        <AccountActivityStats accountId={accountId} />
        <TopVisitors accountId={accountId} />
        <AccountSiteVisitInfoTable accountId={accountId}></AccountSiteVisitInfoTable>

        {explainData && <EngagementScoreSection explainData={explainData} />}
      </div>
    </>
  )
}

export default FeedTab
